module.exports = __webpack_public_path__ + "static/media/mycap_logo.7d28da20.png";